define('views/modules/setting/personal/blocks/custom-messages/custom-messages-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // collections
    'collections/conversation/custom-messages',
    // Views
    'views/parts/list/fetch-list',
    'views/modules/profile/list/custom-messages-list-item',
    'views/modules/profile/edit/custom-message-edit-panel',
    'views/parts/menu/menu-action',
    // Templates Blocks
    'text!templates/modules/setting/personal/blocks/custom-messages/custom-messages-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // collections
    CCustomMessages,
    // Views
    VFetchList,
    VCustomMessagesListItem, //VPersonalDataListItem,
    VCustomMessageEditPanel,
    VMenuAction,
    // Template
    TCustomMessageContent
) {

    var VCustomMessagesContent = Backbone.View.extend({
        template: TCustomMessageContent,
        regions: {
            root: '#custom-messages-content',
            menu: ".menu-actions",
            list: "#custom-message-list",
        },

        initialize: function(options) {
            this.collection = new CCustomMessages({ sort: 'title' });

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-add-custom-message'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddCustomMessage }
                    ]),
                    tooltip: { container: this.regions.root, }
                }),

                list: new VFetchList({
                    collection: this.collection,
                    item: VCustomMessagesListItem,
                    button: {
                        label: 'calendar:Show more personal datas'
                    },
                    bottom: true,
                }),
            };

            this.panel = {};

            this.listenTo(this.collection, {
                "customMessage:click": this.onCustomMessageClick,
            });

            this.listenTo(this.collection, 'change add', this.onCollectionChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

             this.collection.getFirstPage();

            return this;
        },

        lazyInit: function() {
            var view = this.panel.edit;
            if (!view) {
                view = this.panel.edit = new VCustomMessageEditPanel();
                this.listenTo(view, 'form:success', this.onCustomMessageUpdate);
            }

            return view;
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onSave: function() {
            this.submit();
        },

        onCustomMessageUpdate: function(model) {
            this.collection.set(model, { remove: false });
        },

        onAddCustomMessage: function() {
            var panel = this.lazyInit();
            panel.resetModel();
            this.trigger('panel:stack', panel);
        },

        onCustomMessageClick: function(model) {
            var panel = this.lazyInit();
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

        onCollectionChange: function(model) {
            if (model.get('defaultWelcomeMessage')) {
                this.collection.each(function(collectionModel) {
                    if (! collectionModel.is(model)) {
                        collectionModel.set('defaultWelcomeMessage', false);
                    }
                });
            }
        }

    });

    return VCustomMessagesContent;
});

